import AppProjectPage from "../app"
import {Cover} from "../../../../core/model2/task/properties/cover"

export default function page_setCover(cover:Cover | undefined) {

    const app = gd.getApp() as unknown as AppProjectPage;

    if (!app.document) {
        console.warn("page_setCover Error: no document")
        return
    }

    app.document.cover = cover

    app.document.save()

    app.reRender()
}
